<template>
<div>
<div class="content-header text-center">
	<h2>Generate Prospects</h2>
</div>
  <div class="container-fluid min-content-height">

    <div class="row" v-if="passedData.length && passedNames.length">
      <div class="py-4">
        <div class="dropdown">
          <div class="card border border-success bg-dark p-4" role="alert">
            <p class="lead text-white">This pane allows you to select and download a prospect file based on your Analyze Assistant conversation. Using your questions and answers, Analyze Assistant has identified several high propensity consumer variables, which are listed below. You may get better results by limiting your selected variables to those that are most relevant. You can also use other variables and geographies to limit or enhance your search. </p>
          </div>
        </div>
      </div>
    </div>
    <form id="prospects" method="post" :class="{ 'd-none': showCountModal }">
    <div class="row g-3 align-items-center">
    <div class="col-sm">
      <div class="form-group" :class="{ error: v$.form.prospectName.$errors.length }">
        <label for="prospectName" class="form-label"><strong>Prospect File Name</strong><span class="error"> *</span></label>
          <input 
            type="text" 
            @input="validateInput"
            class="form-control form-control-lg" 
            name="prospectName" 
            id="prospectName"
            v-model.trim="v$.form.prospectName.$model" 
          />
          <!-- @input="validateInput" -->
          <div class="input-errors" v-for="(error, index) of v$.form.prospectName.$errors" :key="index">
          <div class="error-msg">{{ error.$message }}</div>
        </div>
      </div>
    </div>
    </div>
    <div class="row g-3 align-items-center">

      <div class="col-sm-8">
        
        <div class="p-2">
        <div class="col mb-2">
          <p class="text-left"><strong>Select look-alike model</strong></p>
          <div class="form-check mr-2">
            <input class="form-check-input" type="radio" v-model="datasourceset" value="us">
              <label class="form-check-label">Find people who look like typical American consumers (use if unsure)</label>
          </div>
        </div>
        <div class="col mb-2">
          <div class="form-check mr-4">
            <input class="form-check-input" type="radio" v-model="datasourceset" value="dataset">
              <label class="form-check-label">Find people who look like a dataset that I uploaded</label>
          </div>
        </div>
         <div class="col mb-2">
          <div class="form-check mr-4">
            <input class="form-check-input" type="radio" v-model="datasourceset" value="config">
              <label class="form-check-label">Use a custom configured model from an MDL file</label>
          </div>
        </div>
        <div class="col mb-2">

          <div v-if="datasourceset === 'us'">
            <label><em>All US Households selected</em></label>
            <input type="hidden" name="prospectsDatasetSelect" value="usdefault" />
          </div>

          <div v-if="datasourceset === 'dataset'">
          <label for="prospectsDatasetSelect" class="form-label">Look-alike Dataset</label>
          <select name="prospectsDatasetSelect" class="form-select">
            <!-- option v-for="option in reports" :value="option" :key="option">{{option}}</option -->
            <option v-for="option in datasets" :value="option" :key="option">{{option}}</option>
          </select>
          </div>

        </div>

          <div v-if="datasourceset === 'config'">
          <label for="prospectsConfigSelect" class="form-label">Select Custom Model</label>
          <select name="prospectsConfigSelect" class="form-select">
            <option v-for="option in sortedConfig" :value="option" :key="option">{{option}}</option>
          </select>
          </div>


      </div>
      
      
    </div>
  
    <div class="col-sm-4">
      <label class="form-label"><strong>Quantity</strong></label>
      <select v-model="expectedCount" class="form-select" @change="prospectsQuantityCalc($event)">
        <option value="100">100</option>
        <option value="500">500</option>
        <option value="1000">1000</option>
        <option value="5000">5000</option>
        <option value="10000">10000</option>
        <option value="20000">20000</option>
        <option value="30000">30000</option>
        <option value="Count Only" selected>Estimate Count</option>
        <option value="addressable_market" v-if="this.isAdmin">Addressable Market</option>
      </select>
    </div>
    </div>
    <div class="row mb-2" :class="assistantClass" v-if="passedData.length && passedNames.length">
      <div class="col-sm-12">
        <div class="flex justify-content-between">
          <h3>Analyze Assistant Selected Variables</h3>
          <div class="container-fluid">
            <div class="row">
              <div v-for="(item, index) in passedNames" class="col-md-6">
                <input type="checkbox" id="checkbox" class="me-2" :value="passedData[index]" v-model="selectedOptions"  />
                <label for="checkbox">{{item}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row align-items-center mb-2">
      <div class="col text-center"><h3>Demographic Variables</h3></div>
    </div>
    <div class="row align-items-top mb-2">
      <div class="col-md-4 mb-2">
        <div class="form-group">
        <label class="mb-2"><strong>Gender</strong></label>
          <select v-model="genderselect" class="form-select">
            <option value="">All</option>
            <option value="M">Male</option> 
            <option value="F">Female</option>
            <option value="U">Other/Unknown</option>
          </select>
        </div>
      </div>
      <div class="col-md-4 mb-2">
        <div class="form-group">
          <label class="mb-2"><strong>Age</strong></label>
          <Slider v-model="ageselect" class="slider-blue mt-5" :min="18" :max="110" />
        </div>
      </div>
      <div class="col-md-4 mb-2">
          <div class="form-group">
            <label class="mb-2"><strong>Home Ownership</strong></label>
              <select v-model="homeselect" class="form-select">
                <option value="">All</option> 
                <option value="R">Rent</option>
                <option value="H">Own</option>
              </select>
            </div>
        </div>
      </div>
      <div class="row align-items-top mb-2">
      <div class="col-md mb-2 d-none">
        <div class="form-group d-none">
          <label><strong>Ethnicity</strong></label>
            <div v-for="option in ethnicityoptions" :key="option.value" class="form-check">
            <input type="checkbox" :value="option.value" v-model="ethnicity" class="form-check-input">
            <label class="form-check-label" >{{ option.label }}</label>
          </div>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="form-group">
            <label class="form-check-label"><strong>Income</strong></label>
            <div class="container-fluid">
              <div class="row">
                <div class="col-lg-6">
                  <div v-for="option in incomeoptions.slice(0, Math.ceil(incomeoptions.length / 2))" :key="option.value" class="form-check" style="width: 50%;">
                    <input type="checkbox" :value="option.value" v-model="incomeselect" class="form-check-input">
                    <label>{{ option.label }}</label>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div v-for="option in incomeoptions.slice(Math.ceil(incomeoptions.length / 2))" :key="option.value" class="form-check" style="width: 50%;">
                    <input type="checkbox" :value="option.value" v-model="incomeselect" class="form-check-input">
                    <label>{{ option.label }}</label>
                  </div>
                </div>
              </div>
          </div>
          </div>
        </div>
        <div class="col-md-3 mb-2">
          <div class="form-group">
            <label class="form-check-label"><strong>Net Worth</strong></label>
            <div v-for="option in networthoptions" :key="option.value" class="form-check">
                <input type="checkbox" :value="option.value" v-model="networthselect" class="form-check-input">
                <label>{{ option.label }}</label>
              </div>
          </div>
        </div>                                
        <div class="col-md-3 mb-2">
          <div class="form-group">
            <label class="form-check-label"><strong>Credit Score</strong></label>
            <div v-for="option in creditoptions" :key="option.value" class="form-check">
              <input type="checkbox" :value="option.value" v-model="creditrating" class="form-check-input">
              <label>{{ option.label }}</label>
            </div>
          </div>
        </div>
        
      </div>
    <!-- geography -->
    <div class="row h-100 p-4">
      <div class="col-sm-12 text-center h-100">
        <button type="button" class="my-auto change-btn btn btn-lg btn-info" value="geo-logic" @click="addNewGeo">
          <i class="fa-solid fa-circle-plus"></i>
          Add Geographic Data
        </button>
      </div>
      <div class="col-sm-12 my-2 text-center h-100" v-if="geoItems.length">
        <button @click.prevent="deleteGeos" class="btn btn-danger rounded">
          <i class="fas fa-trash-can"></i>
          Delete All
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="flex justify-content-between" v-for="(item, index) in geoItems" :key="item.id">
          <ProspectsGeography :geoCompName="item.geoCompName" v-bind:isAdmin="isAdmin" :indexProp="index" @delete-geo="deleteGeo" ref="geocomponents" /> 
        </div>
      </div>
    </div>

    <hr>

    <!-- prospects -->
    <div class="row h-100 p-4">
      <div class="col-sm-12 text-center h-100">
        <button type="button" class="my-auto change-btn btn btn-lg btn-info" value="prospect-logic" @click.prevent="addNewProspect">
          <i class="fa-solid fa-circle-plus"></i>
          Add Prospect Data
        </button>
      </div>
      <div class="col-sm-12 my-1 text-center h-100" v-if="prospectItems.length">
        <button @click.prevent="deleteProspects" class="btn btn-danger rounded">
          <i class="fas fa-trash-can"></i>
          Delete All
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="flex justify-content-between" v-for="(item, index) in prospectItems" :key="index">
          <ProspectList ref="prospListvals" :prospCompName="item.prospCompName" @custom-change-prosp="(value) => customChangeProsp(value)" />
        </div>
      </div>

    </div>


    <div class="row">
      <div class="col-sm-12">
        <button class="btn btn-primary btn-lg" type="button" data-bs-toggle="collapse" data-bs-target="#collapseDedupe" aria-expanded="false" aria-controls="collapseDedupe">Suppression</button>
        <p class="lead mx-2 my-2"><strong><i class="fas fa-asterisk"></i> You can use this field to select datasets containing existing customers or prospects that you wish to suppress from the new prospect file.</strong></p>
        <!-- p><strong>Select lists to remove any duplicate individuals from being added to the current request.</strong></p -->
        <hr>
      </div>
    </div>

    <div class="row collapse" id="collapseDedupe">
      <div class="col-sm-12">
        <div class="form-group">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-4 offset-md-4 text-center">
                  <div class="form-check ms-2 text-left">
                      <input type="checkbox" value="all" :checked="deduplication.includes('all')" @click="handleDedupeClick('all')" class="form-check-input">
                      <label>ALL (Datasets and Prospect Lists)</label>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-md-6">
                  <!-- all prospects -->
                  <div class="form-check ms-2">
                      <input type="checkbox" value="allprospects" :checked="deduplication.includes('allprospects')" @click="handleDedupeClick('allprospects')" class="form-check-input">
                      <label>All Prospect Lists</label>
                  </div>
                  <div v-for="data in prospects" :key="data" class="form-check ms-2">
                      <input type="checkbox" :value="data" :checked="deduplication.includes(data)" @click="handleDedupeClick(data)" class="form-check-input">
                      <label>{{ removeProspectTitle(data) }}</label>
                    </div>
                </div>
                <div class="col-md-6">
                  <!-- all datasets -->

                   <!-- all prospects -->
                  <div class="form-check ms-2">
                      <input type="checkbox" value="alldatasets" :checked="deduplication.includes('alldatasets')" @click="handleDedupeClick('alldatasets')" class="form-check-input">
                      <label>All Dataset Uploads</label>
                  </div>
                  <div v-for="data in datasets" :key="data" class="form-check ms-2">
                      <input type="checkbox" :value="data" :checked="deduplication.includes(data)" @click="handleDedupeClick(data)" class="form-check-input">
                      <label>{{ data }}</label>
                  </div>


                </div>
              </div>
              
              </div>
            </div>
      </div>
    </div>

    <!-- start uniqueperaddress -->
    <div class="row">
      <div class="col-sm-12">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" v-model="uniquePerAddress" value="true" />
          <label class="form-check-label lead mx-2"><strong>Unique Per Address</strong> - Click to limit results to one address per household</label>
        </div>
      </div>
    </div>
    <!-- PQRGenerate -->
    <div class="row">
      <div class="col-sm-12">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" v-model="pqrgenerate" value="true" />
          <label class="form-check-label lead mx-2">Save parameters as editable PQR File?</label>
        </div>
      </div>
    </div>

    <div v-if="prospectBtnDisable" class="p-2 mx-2">Processing request <i class="fa-solid fa-spinner fa-3x fa-spin-pulse fa-spin-reverse"></i></div>
    <div v-if="finalcount" class="p-2 mx-2"><h3>Count result: {{formatNum(finalcount)}}</h3></div>

    <button type="submit" class="btn btn-lg btn-block btn-primary" @click.prevent="submitProspectEvent" :disabled="prospectBtnDisable || v$.form.$invalid || !checkVariableValidation()"><span v-html="buttontxt" /></button>
    <button type="submit" class="btn btn-lg btn-block btn-warning" @click.prevent="refreshOptions">Clear/Refresh</button>
    <p class="lead mt-2" v-if="v$.form.$invalid"><span class="error"><em>* Enter a value in the 'Prospect File Name' field and/or remove any non alphanumeric characters</em></span></p>
    <p class="lead mb-2" v-if="!checkVariableValidation()"><span class="error"><em>* Select atleast one geographical or prospect variable</em></span></p>
  </form>
  <!-- v-if="showCountModal" -->
  <CountModal :class="{ 'd-block': showCountModal, 'd-none': !showCountModal }" v-bind:precount="precount" v-bind:expectedCount="expectedCount" @close-back="closeBack" @continue-processing="continueProcessing" />
  </div>
</div>
</template>
<script>
import useVuelidate from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import axios from 'axios';
import CountModal from "./modal/CountModal.vue";
import ProspectList from "./ProspectsList.vue";
import ProspectsGeography from "./ProspectsGeography.vue";
import Slider from '@vueform/slider';
const alphaDash = (value) => {
  if (!value) {
    return true;
  }
  return /^[a-zA-Z0-9_-]+$/.test(value);
};
export default {
  name: 'prospects',
  components: { ProspectList, ProspectsGeography, Slider, CountModal },
  setup () {
    return {
      v$: useVuelidate()
    }
  },
  data() {
    return {
      geoItems: [],
      countonly: false,
      prospectItems: [],
      counter: 0,
      configs: [],
      datasets: [],
      reports: [],
      prospects: [],
      prospectData: [],
      selectedOptions: [],
      geographyData: [],
      demographicData: [],
      demographicDataCustom: [],
      deduplication: [],
      datasourceset: 'us',
      finalGeo: '',
      finalLogic: '',
      finalDemo: '',
      finalDemoCust: '',
      uniquePerAddress: false,
      pqrgenerate: false,
      ageselect: [18, 100],
      genderselect: [],
      incomeselect: [],
      ethnicity: [],
      networthselect: [],
      creditrating: [],
      showCountModal: false,
      expectedCount: 'Count Only',
      active: false,
      precount: 0,
      incomeoptions: [
        { value: 'A', label: 'Under $10K' }, 
        { value: 'B', label: '$10K-$14K' },
        { value: 'C', label: '$15K-$19K' },
        { value: 'D', label: '$20K-$24K' },
        { value: 'E', label: '$25K-$29K' },
        { value: 'F', label: '$30K-$34K' },
        { value: 'G', label: '$35K-$39K' },
        { value: 'H', label: '$40K-$44K' },
        { value: 'I', label: '$45K-$49K' },
        { value: 'J', label: '$50K-$54K' },
        { value: 'K', label: '$55K-$59K' },
        { value: 'L', label: '$60K-$64K' },
        { value: 'M', label: '$65K-$74K' },
        { value: 'N', label: '$75K-$99K' },
        { value: 'O', label: '$100K-$149K' },
        { value: 'P', label: '$150K-$174K' },
        { value: 'Q', label: '$175K-$199K' },
        { value: 'R', label: '$200K-$249K' },
        { value: 'S', label: '$250K+' }
      ],
      ethnicityoptions: [
        { value: 'A', label: 'Southeast Asian' },
        { value: 'C', label: 'Central &amp; Southwest Asian' },
        { value: 'E', label: 'Eastern European' },
        { value: 'F', label: 'All African American Ethnic Groups' },
        { value: 'I', label: 'Middle Eastern' }, 
        { value: 'J', label: 'Jewish' },
        { value: 'M', label: 'Mediterranean' }, 
        { value: 'N', label: 'Native American' },
        { value: 'O', label: 'Far Eastern' },
        { value: 'P', label: 'Polynesian' },
        { value: 'S', label: 'Scandinavian' },
        { value: 'T', label: 'Other' },
        { value: 'U', label: 'Miscellaneous Other' }, 
        { value: 'W', label: 'Western European' },
        { value: 'Y', label: 'Hispanic' },
        { value: 'Z', label: 'Uncoded (No Group)' }
      ],
      networthoptions: [
        { value: 'A', label: 'Less than $1' }, 
        { value: 'B', label: '$1-$4K' },
        { value: 'C', label: '$5K-$9K' },
        { value: 'D', label: '$10K-$24K' },
        { value: 'E', label: '$25K-$49K' },
        { value: 'F', label: '$50K-$99K' },
        { value: 'G', label: '$100K-$249K' },
        { value: 'H', label: '$250K-$499K' },
        { value: 'I', label: 'Greater than $499K' }
      ],
      creditoptions: [
        { value: 'A', label: '800+' }, 
        { value: 'B', label: '750-799' },
        { value: 'C', label: '700-749' },
        { value: 'D', label: '650-699' },
        { value: 'E', label: '600-649' },
        { value: 'F', label: '550-599' },
        { value: 'G', label: '500-549' },
        { value: 'H', label: 'under 499' },
      ],
      homeselect: '',
      finalcount: 0,
      percent: 10,
      lpin: false,
      buttontxt: 'Estimate Prospect Count',
      prospectBtnDisable: false,
      form: {
        prospectName: ''
      }
    }
  },
  props: {
    passedData: [],
    passedNames: [],
    isAdmin: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  validations () {
    return {
      form: {
        prospectName: {
          required, 
          alphaDash: helpers.withMessage('Enter only alphanumeric characters, dashes and underscores', alphaDash)
          //required
        }
      }
    }
  },
  mounted () {
    axios({
      method : 'POST',
      url : '/check_lpin',
      data:'',
    }).then(
      (response) => {
      this.lpin = response.data;
      })
      .catch(error => {
        this.errorMessage = error.message;
        console.error("There was an error!", error);
    });
    axios({
      method : 'POST',
      url : '/list_datasets',
      data:'',
    }).then(response => this.datasets = processDatasetList(response.data))
      .catch(error => {
        this.errorMessage = error.message;
        console.error("There was an error!", error);
    });
    axios({
      method : 'POST',
      url : '/list_reports',
      data:'',
    }).then(response => this.reports = processDatasetList(response.data))
      .catch(error => {
        this.errorMessage = error.message;
        console.error("There was an error!", error);
    });
    axios({
      method : 'POST',
      url : '/list_datasets',
      data:'',
    }).then(response => this.prospects = processProspects(response.data))
      .catch(error => {
        this.errorMessage = error.message;
        console.error("There was an error!", error);
    });
    this.getMDLFiles();
  },
  methods: {
    getMDLFiles() {
      let formData = new FormData();
      formData.append('extension', '.mdl');
      axios({
        method : 'POST',
        url : '/user_config_list',
        data:formData,
      }).then(
        (response) => {
          this.configs = response.data;
          //console.log('list of config files '+response.data);
        })
        .catch(error => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
      });
    },
    handleDedupeClick(value) {
      if (value === 'all') {
        this.deduplication = ['all'];
      } else if (value === 'allprospects') {
        this.deduplication = ['allprospects'];
      } else if (value === 'alldatasets') {
        this.deduplication = ['alldatasets'];
      } else {
        this.deduplication = this.deduplication.filter(item => 
          !['all', 'allprospects', 'alldatasets'].includes(item)
        );
        if (!this.deduplication.includes(value)) {
          this.deduplication.push(value);
        }
      }
    },
    validateInput(event) {
      event.target.value = event.target.value.replace(/[^a-zA-Z0-9_-]/g, '');
    },
    removeProspectTitle(val) {
      return val.replace('.prospect', '');
    },
    assistantClass() {
      if(this.passedData && this.passedNames) {
        return '';
      } else {
        return ' d-none';
      }
    },
    checkVariableValidation() {
      if(this.geoItems.length > 0 || this.selectedOptions.length > 0 || this.prospectItems.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    removeSpaces(event) {
      event.target.value = event.target.value.replace(/\s/g, '');
    },
    collectGeographyData() {
      if (Array.isArray(this.$refs.geocomponents)) {
        this.geographyData = this.$refs.geocomponents
          .map(component => component.getSelectedGeo())
          .filter(Boolean);
        this.finalGeo = this.geographyData.join('\n');
      } else {
        this.geographyData = [];
        this.finalGeo = '';
      }
      if(this.uniquePerAddress) {
        this.finalGeo  += '\nuniquePerAddress';
      }
      this.finalDemoCust = this.demographicDataCustom.join('\n').concat('');
      this.finalGeo  += '\n'+this.finalDemoCust;
      
      //console.log('compile geo '+JSON.stringify(this.finalGeo));
    },
    adjustOption(name) {
      return 'appeneded-'+name;
    },
    updateAIArr(event) {
      var theval = event.target.value;
      //console.log('selected '+theval);
    },
    addNewGeo() {
      this.geoItems.push({ id: Date.now(), geoCompName: "ProspectsGeography" });
    },
    deleteGeos() {
      this.geoItems = [];
      this.geographyData = [];
      this.finalGeo = '';
    },
    deleteGeo(theval) {
      //console.log('emitted value being deleted '+theval);
      this.geoItems.splice(theval, 1);
      this.$nextTick(() => {
        this.updateIndices();
      });
    },
    updateIndices() {
      this.$refs.geocomponents.forEach((component, idx) => {
        component.updateIndex(idx);
      });
    },
    addNewProspect() {
      this.prospectItems.push({ prospCompName: "ProspectsList" });
    },
    deleteProspects() {
      this.prospectData = [];
      this.prospectItems = [];
      this.finalLogic = [];
      //console.log('prospect items '+JSON.stringify(this.prospectItems));
      //console.log('final logic '+JSON.stringify(this.finalLogic));
    },
    prospectsQuantityCalc(event) {
      //console.log('Pressed! ');
      //console.log('selected event is '+event.target.value);
      if(event.target.value == 'Count Only') {
        this.buttontxt = 'Estimate Prospect Count';
      } else {
        this.buttontxt = 'Generate Prospects';
        this.finalcount = 0;
      }
    },
    customChangeProsp(value) {
        this.prospectData.push(value);
    },
    querySelectedAIvars() {
        var curArr = [];
        curArr = this.selectedOptions;
        curArr.forEach(item => {
          this.customChangeProsp(item);
        });
    },
    queryDemographics() {
            this.demographicData = [];
            this.demographicDataCustom = [];
            if(this.ageselect.length > 1) {
                this.demographicData.push('AGE='+this.formatAge(this.ageselect));
            };
            if(this.genderselect.length >= 1) {
                this.demographicData.push('GENDER='+this.genderselect);
            };
            if(this.incomeselect.length >= 1) {
                this.demographicDataCustom.push('!HH_INCOME='+this.formatDem(this.incomeselect));
            };
            if(this.ethnicity.length >= 1) {
                this.demographicDataCustom.push('!ETHNIC_GRP='+this.formatDem(this.ethnicity));
            };
            if(this.networthselect.length >= 1) {
                this.demographicDataCustom.push('!NET_WORTH='+this.formatDem(this.networthselect));
            };
            if(this.creditrating.length >= 1) {
                this.demographicDataCustom.push('!CREDIT_RATING='+this.formatDem(this.creditrating));
            };
            if(this.homeselect == 'R' || this.homeselect == 'H') {
                this.demographicData.push('HOME_OWNR='+this.homeselect);
            };
    },
    formatDem(val) {
      var endval = val.join('');
      return '['+endval+']';
    },
    formatAge(val) {
      var endval = val.join('-');
      return endval;
    },
    formatNum(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    compileOptions() {
      this.finalDemo = this.demographicData.join('\n').concat('');
      this.finalLogic = this.prospectData.map(item => item.includes('A360_CLUST') ? item : item + '=Y').join('\n');
      this.finalLogic += '\n'+this.finalDemo;
    },
    refreshOptions() {
      this.geoItems = [],
      this.countonly = false,
      this.prospectItems = [],
      this.counter = 0,
      this.configs = [],
      this.datasets = [],
      this.reports = [],
      this.prospectData = [],
      this.selectedOptions = [],
      this.geographyData = [],
      this.demographicData = [],
      this.demographicDataCustom = [],
      this.datasourceset = 'us',
      this.finalGeo = '',
      this.finalLogic = '',
      this.finalDemo = '',
      this.finalDemoCust = '',
      this.uniquePerAddress = false,
      this.ageselect = [18, 100],
      this.genderselect = [],
      this.incomeselect = [],
      this.ethnicity = [],
      this.networthselect = [],
      this.creditrating = [],
      this.homeselect = '',
      this.finalcount = 0,
      this.percent = 10,
      this.lpin = false,
      this.buttontxt = 'Generate Prospects',
      this.prospectBtnDisable = false,
      this.form.prospectName = '';
      this.showCountModal = false;
      this.expectedCount = 'Count Only';
      this.active = false;
      this.precount = 0;
    },
    async getthecount() {
      this.prospectBtnDisable = true;
      this.buttontxt = '<i class="fa-solid fa-spinner fa-spin-pulse fa-spin-reverse"></i> Processing.... ';
      await this.v$.form.prospectName.$touch();
      const isFormCorrect = await this.v$.form.$invalid;
      if (!isFormCorrect) {
        //if(this.passedData && this.passedNames) {
          //this.querySelectedAIvars();
        //};
        // this.queryDemographics();
        const initialFormData = new FormData(document.getElementById("prospects"));
        // this.compileOptions();
        // this.collectGeographyData();
        initialFormData.append('optionsArea', this.finalLogic);
        initialFormData.append('geographyArea',this.finalGeo);
        initialFormData.append('percent', this.percent);
        initialFormData.append('prospectsQuantity', 'Count Only');
        const serializedProspects = new URLSearchParams(initialFormData).toString();
        // this.$emit('decreaseProspectCount');
        // this.$emit('updateUserSessionData');
        await axios.post('/prospect_download', {
          body: serializedProspects
        })
        .then(
        (response) => {
            this.precount = response.data;
            this.showCountModal  = true;
        })
        .catch(
        (error) => {
          console.log(error);
          console.log('form submit failed');
        });
      } else {
        console.log('Form is NOT VALID');
      } 
    },
    async processProspectEvent() {
      this.prospectBtnDisable = true;
      this.buttontxt = '<i class="fa-solid fa-spinner fa-spin-pulse fa-spin-reverse"></i> Processing.... ';
      await this.v$.form.prospectName.$touch();
      const isFormCorrect = await this.v$.form.$invalid;
      if (!isFormCorrect) {
        const initialFormData = new FormData(document.getElementById("prospects"));
        initialFormData.append('optionsArea', this.finalLogic);
        initialFormData.append('geographyArea',this.finalGeo);
        initialFormData.append('percent', this.percent);
        initialFormData.append('prospectsQuantity', this.expectedCount);
        initialFormData.append('deduplicate', JSON.stringify(this.deduplication));
        const serializedProspects = new URLSearchParams(initialFormData).toString();
        this.$emit('decreaseProspectCount');
        this.$emit('updateUserSessionData');
        //console.log('THE FINAL filename is: ', this.form.prospectName);
        //console.log('THE FINAL serialized request is: ', serializedProspects);
        if(this.pqrgenerate) {
          //console.log('Generating PQR data....');
          this.createPQRFile(serializedProspects);
        };
        axios.post('/prospect_download', {
          body: serializedProspects
        })
        .then(
        (response) => {
          var testresult = response.data;
          if(response.data) {
            this.finalcount = testresult;
            this.buttontxt = 'Estimate Prospect Count';
            this.prospectBtnDisable = false;
          } else {
            this.$emit('messageAlert', {alert: 'Your prospect data is being processed and will be available in a few minutes.', classel: 'info'});
            this.$emit('customChange', {shell: 'ProspectsDashboard', dataset: ''});
          }
        })
        .catch(
        (error) => {
          console.log(error);
          console.log('form submit failed');
        });
      } else {
        console.log('Form is NOT VALID');
      }
    },
    createPQRFile(serializedfinaldata) {
      let formData = new FormData();
      formData.append('name', this.form.prospectName+'_prospect');
      formData.append('contents', serializedfinaldata);
      formData.append('extension', ".pqr")
      axios({
        method : 'POST',
        url : '/user_config_save',
        data:formData,
      }).then(
        (response) => {
          console.log('save file response '+JSON.stringify(response.data));
        })
        .catch(error => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
      });
    },
    submitProspectEvent() {
      if(this.passedData && this.passedNames) {
        this.querySelectedAIvars();
      };
      this.queryDemographics();
      this.compileOptions();
      this.collectGeographyData();
      if(this.expectedCount == "Count Only") {
        this.processProspectEvent();
      } else {
        this.getthecount();
      }   
    },
    continueProcessing(){
      this.showCountModal = false;
      this.processProspectEvent();
    },
    closeBack() {
      this.showCountModal = false;
      this.buttontxt = 'Generate Prospects';
      this.prospectBtnDisable = false;
    },
    checkDatasetLoad(curDataset) {
      if(this.reports.indexOf(curDataset) !== -1) {
        return true;
      } else {
        return false;
      }
    }
  },
  computed: {
      sortedConfig() {
        return [...this.configs].sort();
      }
  }
}
function processDatasetList(data) {
      var iH = [];
      var i;
      var b = data;
      for (i = 0; i < b.length; i++) {
        if (b[i].includes('scored-') || b[i].includes('prospect'))
          continue;
            iH.push(b[i]);
      };
      return iH;
}
function processProspects(data) {
      var iH = [];
      var i;
      var b = data;
      for (i = 0; i < b.length; i++) {
        if (b[i].includes('scored-') || !b[i].includes('prospect'))
          continue;
            iH.push(b[i]);
      };
      return iH;
}
</script>
<!-- style src="@vueform/slider/themes/default.css"></style -->
